import { LetterTypes } from './LetterTypes';
import { CheckEmptyOrWhitespace } from '@/Shared/Validator';
import { Appeal } from './Appeal';

export class AppealInfo {
    public appeal: Appeal = new Appeal();
    public appealLetterType: number | null = 0;
    public appealLetterList: LetterTypes[] | null = null;
    public requestForAppealDate: Date | null = new Date();
    public reviewDate: Date | null = new Date();
    public appellantNotifiedDate: Date | null = new Date();
}

export function PrepareAppeal(appealInfo: AppealInfo): AppealInfo {
    let newAppealInfo = new AppealInfo();
    if (appealInfo != null) {
        newAppealInfo = appealInfo;
        if (newAppealInfo.hasOwnProperty('appeal')) {
            if (newAppealInfo.appeal.hasOwnProperty('requestForAppealDate')
            && !CheckEmptyOrWhitespace(newAppealInfo.appeal.requestForAppealDate, 'date')) {
                if (newAppealInfo.appeal.requestForAppealDate != null) {
                    const str = newAppealInfo.appeal.requestForAppealDate.toString();
                    newAppealInfo.requestForAppealDate = new Date(str.replace('T', ' '));
                }
            }
            if (newAppealInfo.appeal.hasOwnProperty('reviewDate')
            && !CheckEmptyOrWhitespace(newAppealInfo.appeal.reviewDate, 'date')) {
                if (newAppealInfo.appeal.reviewDate != null) {
                    const str = newAppealInfo.appeal.reviewDate.toString();
                    newAppealInfo.reviewDate = new Date(str.replace('T', ' '));
                }
            }
            if (newAppealInfo.appeal.hasOwnProperty('appellantNotifiedDate')
            && !CheckEmptyOrWhitespace(newAppealInfo.appeal.appellantNotifiedDate, 'date')) {
                if (newAppealInfo.appeal.appellantNotifiedDate != null) {
                    const str = newAppealInfo.appeal.appellantNotifiedDate.toString();
                    newAppealInfo.appellantNotifiedDate = new Date(str.replace('T', ' '));
                }
            }
        } else {
            newAppealInfo.appeal = new Appeal();
        }
    }
    return newAppealInfo;
}
